import React from "react";
import "./modal.css"; // Arquivo CSS para estilização (opcional)

const Modal = ({ tipo, style, isOpen, onClose, children, className }) => {
  if (!isOpen) return null;

  return (
    <div className={className}>
      
      <div style={style} className={tipo == 'data' ? "modal-content-data" : "modal-content"} onClick={(e) => e.stopPropagation()}>
      
        <button className="modal-close" onClick={onClose}>
          &times;
        </button>
        {children}
      </div>
    </div>
  );
};

export default Modal;